import {Shadow} from '@styles/reusable';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {animated, useSpring} from 'react-spring';
import {Background, Knob, ToggleContainer} from './Toggle.styled';

const AnimatedKnob = animated(Knob);

const Toggle = ({ selected, disabled = false, onChange, className = '' }) => {
  const [value, setValue] = useState(selected || false);

  useEffect(() => {
    setValue(selected || false);
  }, [selected]);

  const handleChange = useCallback(
    (e) => {
      e.preventDefault();
      if (disabled) return;
      const nextValue = !value;
      setValue(nextValue);
      onChange && onChange(nextValue);
    },
    [value, onChange],
  );

  const spring = useSpring(
    useMemo(
      () => ({
        config: { tension: 350 },
        transform: value ? 'translate3d(20px, 0, 0)' : 'translate3d(0px, 0, 0)',
      }),
      [value],
    ),
  );


  return (
    <ToggleContainer disabled={disabled} selected={value} onClick={handleChange} className={className}>
      <Background />
      <AnimatedKnob style={{ transform: spring.transform }} />
      <Shadow size={2} rounding={100}></Shadow>
    </ToggleContainer>
  );
};

export default Toggle;
